module.exports = require("@material-ui/icons/Warning");